import { ApiFieldError } from 'src/types';
import { AccountOpenContent } from 'src/types/AccountOpenId';
import { actionCreatorFactory } from 'typescript-fsa';

export interface AccountOpenid {
  accountOpenid: string;
}

type APIError = ApiFieldError;

export type UpdateaccountOpenidParams = Partial<AccountOpenContent>;

/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(`@@manager/accountOpenId`);

export const accountOpenidRequest = actionCreator('request');

export const accountOpenidRequestSuccess =
  actionCreator<AccountOpenid>('success');

export const accountOpenidRequestFail = actionCreator<APIError[]>('fail');

export const updateaccountOpenidActions = actionCreator.async<
  UpdateaccountOpenidParams,
  AccountOpenid,
  APIError[]
>(`update`);
